import React, { useEffect, useState, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';


import { ServicioObjetos } from '../../../servicios/ServicioObjetos';
import { ServicioArchivos } from '../../../servicios/ServicioArchivos';
import { ServicioFormatos } from '../../../servicios/ServicioFormatos';
import { ServicioHttp } from '../../../servicios/ServicioHttp';
import { USUARIO_KEY } from '../../../servicios/Constantes';

export const TablaResultados = (props) => {

    const { paginacion ,toast} = props;
    const [rows, setRows] = useState(0);
    const [first, setFirst] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const dt = useRef(null);
    const dtC=useRef(null);
    const [cfdi, setCfdi] = useState({});
    const [modalEnvioCorreo, setModalEnvioCorreo] = useState(false);
    const [modalUsuario, setModalUsuario] = useState(false);
    const [usuario, setUsuario] = useState(false);
    const [envioCorreo, setEnvioCorreo] = useState({});
    const [erroresCorreo, setErroresCorreo] = useState({});
    const [erroresUsuario, setErroresUsuario] = useState({});
    const [listaEnvioCorreo, setListaEnvioCorreo] = useState([]);
    

    const { funcionPaginacion,asignarRestricciones } = props;
    useEffect(() => {
        setRows(paginacion.registrosPorPagina);
        setTotalRecords(paginacion.registrosTotales);
    }, [paginacion]);

    const handleChange = e => {
        const { name, value } = e.target;
        setEnvioCorreo(valoresUsuarioPrevios => ({
            ...valoresUsuarioPrevios,
            [name]: value
        }));
    };

    const handleChangeUsuario = e => {
        const { name, value } = e.target;
        setUsuario(valoresUsuarioPrevios => ({
            ...valoresUsuarioPrevios,
            [name]: value
        }));
    };

    const onIndexTemplate = (rowData, column) => {
        return <div>
           
                <React.Fragment>
                    <Button icon="pi pi-send" title="Enviar recibo de Nómina por Correo" className="p-button-rounded p-button-info p-mr-2" onClick={() => enviarPorCorreo(rowData)} />
                </React.Fragment>
               
        </div>
    }

    const enviarPorCorreo = (objeto) => {
        setModalEnvioCorreo(true);
        setCfdi(objeto);



    }

    const onPage = (event) => {
        setFirst(event.first);
        setRows(event.rows);
        setCurrentPage(event.page + 1);
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        funcionPaginacion(paginacion);
    }

    const descargaMasiva = () => {
        asignarRestricciones()
        ServicioArchivos.descargaArchivo("/cfdi/descarga_masiva_criterios.json", paginacion);
    }

    const header = (
        paginacion.registrosTotales > 0 ?
        <div >
          <div>Total de registros encontrados {paginacion.registrosTotales}</div>
          <br>
          </br>
          <br>
          </br>
         
         </div>
        
        :null

        
        
    );

    const columnaFecha = (rowData, column) => {
        return ServicioFormatos.formatearFechaPago(rowData.fechaPago);
    }

    const columnaMoneda = (rowData, column) => {
        return ServicioFormatos.formatearModena(rowData.total);
    }

    const columnaXml = (rowData, column) => {
        return (
            <div>
            {rowData.estado === 1 ?
            <React.Fragment>
                <Button icon="pi pi-file" className="p-button-rounded p-button-success p-mr-2" onClick={() => descargarXMl(rowData)} />
            </React.Fragment>
            :""}
            </div>
        );
    }

    const columnaPdf = (rowData, column) => {
        return (
            <div>
            {rowData.estado === 1 ?
            <React.Fragment>
                <Button icon="pi pi-file-pdf" className="p-button-rounded p-button-info p-mr-2" onClick={() => descargarPDF(rowData)} />
            </React.Fragment>
            :""}
            </div>
        );
    }

    const descargarXMl = (object) => {
        ServicioArchivos.descargaArchivo(`documento/descarga_archivo.json?id=${object.id}&tipo=xml`, null);
    }

    const descargarPDF = (object) => {
        ServicioArchivos.descargaArchivo(`documento/descarga_archivo.json?id=${object.id}&tipo=pdf`, null);
    }

    const cerrarModalCorreos = () => {
        setModalEnvioCorreo(false);
    }

    const cerrarModalUsuario = () => {
        setModalUsuario(false);
    }

    

    const enviarCorreo = (rowData, column) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-send" className="p-button-info p-mr-2" onClick={() => enviarCorreousuario()} label="Enviar" />
            </React.Fragment>
        );
    }

    const footerUsuario = (rowData, column) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-send" className="p-button-info p-mr-2" onClick={() => enviarUsuario()} label="Guardar" />
            </React.Fragment>
        );
    }
    const enviarUsuario = () => {
        let url = "usuario/editar.json";
        ServicioHttp.consumirPostHttp(url, usuario).then((response) => {
           props.funcionPaginacion(paginacion);
            cerrarModalUsuario();
            toast.current.show({ severity: 'info', summary: 'Success', detail: 'Usuario guardado con éxito', life: 3000 });

        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: '', detail: error.response.data.mensaje, life: 3000 });
        });
   

    }

    

    

    const enviarCorreousuario=()=>{
        try {
            if(ServicioObjetos.esObjetoVacio(listaEnvioCorreo))
               throw new Error('Debes ingresar al menos un correo'); 

               ServicioHttp.consumirPostHttp('envio_correo/enviar.json', listaEnvioCorreo).then(response => {
                setModalEnvioCorreo(false);
                setEnvioCorreo({});
                setListaEnvioCorreo([]);

            }).catch(error => {
               
                toast.current.show({ severity: 'error', summary: '', detail: "Error de conexion al servidor", life: 8000 });
            });
        } catch (error) {
            
            toast.current.show({ severity: 'error', summary: '', detail: error.message, life: 8000 });
        }
    }

    const eliminarCorreo=(rowData, column)=>{
        return (
            <React.Fragment>
                <Button icon="pi pi-trash" className="p-button-rounded p-button-info p-mr-2" onClick={() => quitarCorreoLista(rowData)} />
            </React.Fragment>
        );
    }

    const quitarCorreoLista=(rowData)=>{
        listaEnvioCorreo.splice(listaEnvioCorreo.indexOf(rowData), 1);
        setListaEnvioCorreo(listaEnvioCorreo);
        dtC.current.reset();
    }

    const agregarCorreos = () => {

        let erroresFrmLogin = validarEnvioCorreo();
        setErroresCorreo(erroresFrmLogin);
        if (ServicioObjetos.esObjetoVacio(erroresFrmLogin)) {
            envioCorreo['ttCfdi']=cfdi;
            envioCorreo['fechaCreacion']=new Date().getTime();
            envioCorreo['estado']=0;
            listaEnvioCorreo.push(envioCorreo);
            setEnvioCorreo({});
            setListaEnvioCorreo(listaEnvioCorreo);
        }

    }

    const columnaEditar = (rowData) => {
       
        return (
            <div className="actions">
                <Button type="button" icon="pi pi-pencil" onClick={() => editarUsuario(rowData)} className="p-button-success" />
            </div>
        );
    }

    const editarUsuario=(rowData)=>{
        setUsuario(rowData);
        setModalUsuario(true);
    }

    const validarEnvioCorreo = () => {
        console.log(envioCorreo);
        const errores = {};
        if (ServicioObjetos.esObjetoVacio(envioCorreo.direccion))
            errores.direccion = "Correo es requerido";
        return errores;
    }

    const columnaEstado = (rowData, column) => {

        if(rowData.estado === 3){
            return <>
          <React.Fragment>
                    <Button icon="pi pi-stop-circle" title="Error" className="p-button-rounded p-button-warning p-mr-2" />
                </React.Fragment>
        </>
        }

        if(rowData.estado === 1){
            return <>
          <React.Fragment>
                    <Button icon="pi pi-check" title="Activo" className="p-button-rounded p-button-info p-mr-2" />
                </React.Fragment>
        </>
        }

        if(rowData.estado === 2){
            return <>
           <React.Fragment>
                    <Button icon="pi pi-times" title="Cancelado" className="p-button-rounded p-button-danger p-mr-2" />
                </React.Fragment>
        </>
        }        
    }

    return (

        <div className="grid table-demo">
           <div className="col-12">
                <div className="card">
               
                    <h5>Usuarios</h5>
                    <DataTable header={header} ref={dt} value={paginacion.datos} className="p-datatable-gridlines" showGridlines
                        paginator lazy responsiveLayout="scroll"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Mostrando {first} al {last} de {totalRecords} registros"
                        rows={rows} first={first} totalRecords={totalRecords}
                        rowsPerPageOptions={[10, 20, 40, 60, 80, 100]} onPage={onPage}>
                        <Column header="Enviar por Correo" body={onIndexTemplate} style={{ width: '40px' }} />
                        <Column field="usuario" header="Nombre de Usuario" />
                        <Column field="correo" header="correo" />
                        <Column  header="editar" body={columnaEditar} />
                    </DataTable>
                </div>
            </div> : ""}

            <Dialog header="Header" visible={modalEnvioCorreo} style={{ width: '50vw' }} footer={enviarCorreo} onHide={cerrarModalCorreos}>
                <div className="p-grid p-fluid">
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="fechaFinal">*Agrega correos:</label>
                    </div>
                    <div className="p-col-12 p-md-10">
                        <InputText placeholder="Escribe el correo" name="direccion" className={erroresCorreo.direccion ? 'p-error' : ''} value={envioCorreo.direccion || ""}
                            onChange={handleChange} style={{ width: '100%' }} />
                        {erroresCorreo.direccion ? <div><br /> <Message severity="error" text={erroresCorreo.direccion} /> </div> : null}
                    </div>
                    <div className="p-col-12">
                        <Button label="Agregar" className="teal-btn flat-btn" onClick={agregarCorreos}></Button>
                    </div>

                    <div className="p-col-12">
                        <DataTable ref={dtC} value={listaEnvioCorreo} className="p-datatable-gridlines" showGridlines responsiveLayout="scroll">
                            <Column field="direccion" header="Correo" />
                            <Column body={eliminarCorreo} header="Opciones" />
                        </DataTable>

                    </div>

                </div>
            </Dialog>



            <Dialog header="Header" visible={modalUsuario} style={{ width: '50vw' }} footer={footerUsuario} onHide={cerrarModalUsuario}>
                <div className="p-grid p-fluid">
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="correo">Correo:</label>
                    </div>
                    <div className="p-col-12 p-md-10">
                        <InputText placeholder="correo" name="correo" className={erroresUsuario.correo ? 'p-error' : ''} value={usuario.correo || ""}
                            onChange={handleChangeUsuario} style={{ width: '100%' }} />
                        {erroresUsuario.correo ? <div><br /> <Message severity="error" text={erroresUsuario.correo} /> </div> : null}
                    </div>
                    

              

                </div>
            </Dialog>

        </div>
    );
}
